module.exports = __webpack_public_path__ + "img/526eb98.jpg";